import $ from 'jquery';

export default class QuestionRoom {
  constructor(questionroom, _paq) {
    this.totalSteps = $(".question-step").length;
    this.answersMap = new Map(); // Ajout pour stocker les réponses
    this.errorMessage = questionroom.errorMessage; // Stocker la valeur dans une variable locale

    this.expandStep(1); // Ajout pour afficher la première étape

    $(".next-step").on("click", () => {
      const currentStep = parseInt($(".question-step.active").attr("data-step"));
      const answer = $('input[name="step-' + currentStep + '-answer"]:checked').val();
      if (answer) {
        // Ajout pour stocker la réponse
        this.answersMap.set(currentStep, answer);
        this.expandStep(currentStep + 1);
      }
    });

    $(".submit-answers").on("click", () => {
      // Vérifier si toutes les questions ont été répondues
      if (this.answersMap.size !== this.totalSteps) {
        // Afficher le message d'erreur
        this.showErrorMessage();
        return;
      }
    
      // Convertir les réponses en tableau
      const answers = Array.from(this.answersMap.values());
      // Compter les réponses
      const counts = {};
      for (let i = 0; i < answers.length; i++) {
        const answer = answers[i];
        counts[answer] = counts[answer] ? counts[answer] + 1 : 1;
      }
    
      // Trouver la réponse la plus fréquente
      const mostFrequentAnswers = getMostFrequentAnswers(counts);
    
      // Vérifier si Matomo est actif
      if (typeof _paq !== 'undefined') {
        // Envoyer les résultats à Matomo
        const eventCategory = 'Quizz Results';
        const eventAction = 'Most Frequent Answers';
        const eventLabel = mostFrequentAnswers.join(', ');
    
        _paq.push(['trackEvent', eventCategory, eventAction, eventLabel]);
      }
    
      // Afficher le résultat
      $(".results > *").hide();
      mostFrequentAnswers.forEach((answer) => {
        $(".results > #" + answer).slideDown();
      });
    
      let countAnswers = mostFrequentAnswers.length;
    
      if (countAnswers > 0) {
        $('.question-title .count-results').html(countAnswers);
        $('.question-title .text-count').show();
        $('.question-title .count-results').show();
        $('.question-title .spacer').show();
        
        $("html, body").animate(
          {
            scrollTop: $('.result').offset().top - 50,
          },
          1000
        );
      }
    });
    
    

    // Ajout pour permettre la modification des choix après la soumission
    $('input[name^="step-"]').on('change', (event) => {
      const name = event.target.name;
      const step = parseInt(name.match(/^step-(\d+)/)[1]);
      const answer = $('input[name="' + name + '"]:checked').val();
      if (answer) {
        this.answersMap.set(step, answer);
      } else {
        this.answersMap.delete(step);
      }
    });

    // Ajout pour gérer l'effet d'expansion/réduction sur la classe .question-step
    $('.question-step .question-title').on('click', function () {
      const questionStep = $(this).closest('.question-step');
      questionStep.toggleClass('active');
      questionStep.find('.questions-wrapper').slideToggle();
    });

    // Ajout pour réinitialiser les réponses et les étapes lors du clic sur le bouton "reset-answers"
    $(".reset-answers").on("click", () => {
      // Fermer toutes les questions sauf la première
      $('.question-step').removeClass('active');
      $('.question-step .questions-wrapper').slideUp();

      // Réinitialiser les éléments liés aux résultats
      $('.question-title .text-count').hide();
      $('.question-title .count-results').hide();
      $('.question-title .spacer').hide();
      $(".results > *").hide();
      
      // Réinitialiser les réponses et les étapes
      this.answersMap.clear();
      $('input[name^="step-"]').prop('checked', false);
      this.expandStep(1);
      
      // Animation de défilement fluide (scroll smooth) jusqu'au début du quizz
      $('html, body').animate({
        scrollTop: $('#quizz').offset().top
      }, 800);
    });

    // Réinitialiser les réponses et les étapes lors du chargement de la page
    $(document).ready(() => {
      this.answersMap.clear();
      $('input[name^="step-"]').prop('checked', false);
      this.expandStep(1);
    });
  }

  expandStep(step) {
    $('.question-step').removeClass("active");
    $('.question-step .questions-wrapper').slideUp();

    const currentStep = $('.question-step[data-step="' + step + '"]');
    currentStep.addClass("active");
    currentStep.find('.questions-wrapper').slideDown();
  }

  showErrorMessage() {
    const errorMessage = $('<p class="error-message">' + this.errorMessage + '</p>');
    errorMessage.insertBefore('#quizz > .container > .row');
    errorMessage.fadeIn();

    // Animation de défilement vers l'élément Error Message
    $('html, body').animate({
      scrollTop: errorMessage.offset().top - 20
    }, 800);
    
    // Disparition automatique de l'erreur après quelques secondes
    setTimeout(() => {
      errorMessage.fadeOut(() => {
        errorMessage.remove();
      });
    }, 3000);
  }
}

function getMostFrequentAnswers(counts) {
  const maxCount = Math.max(...Object.values(counts));
  return Object.keys(counts).filter((answer) => counts[answer] === maxCount);
}
